import { useEffect, useState } from 'react'

import { MediaFileClient } from 'api/clients/MediaFileClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { AlmanacFile } from 'types'

export const useMaximalAlmanacFile = (id: string, onError?: () => void) => {
  const [almanacFile, setAlmanacFile] = useState<AlmanacFile>()

  useEffect(() => {
    const fetchAlmanacFile = async () => {
      const res = await MediaFileClient.getAlmanacFile(id)

      if (res.type === SUCCESS_RESPONSE_TYPE) {
        setAlmanacFile(res.data.almanac_file)
      } else {
        reportError('File not found', {
          severity: 'error',
          metaData: { fileId: id, res },
        })

        showToastMessage('File not found.', 'error')
        onError?.()
      }
    }

    if (id && !almanacFile) fetchAlmanacFile()
  }, [id, almanacFile, onError])

  return { almanacFile }
}
